<template lang="pug">
.container.grid-lg
  .text-bold.my-2.py-2 Relatórios disponíveis para OS-m
  .columns
    .column.col-4.col-lg-6.col-md-12.mb-2.pb-2(v-for="item in items")
      row(v-bind="item", v-acl:allowed="item.acl")
</template>

<script>
import Row from "../components/ReportRow"

export default {
  components: { Row },
  computed: {
    items() {
      return [
        {
          icon: "fa fa-bookmark",
          title: "Situações por meses",
          subtitle: "Quantidade de OS-m mensal por situação",
          to: { name: "app.indicadores.osm.situacoesByMonth" },
          acl: [
            "admin",
            "indicadores",
            "ordem_servicos",
            "situacoes_por_meses",
          ],
        },
        {
          icon: "fa fa-tag",
          title: "Por assunto",
          subtitle: "Quantidade de OS-m mensal por assunto",
          to: { name: "app.indicadores.osm.porAssunto" },
          acl: ["admin", "indicadores", "ordem_servicos", "assuntos"],
        },
        {
          icon: "fa fa-users",
          title: "Por Grupo",
          subtitle: "Quantidade de OS-m grupo",
          to: { name: "app.indicadores.osm.porGrupo" },
          acl: ["admin", "indicadores", "ordem_servicos", "grupos"],
        },
        {
          icon: "fa fa-user",
          title: "Por fiscal e meses",
          subtitle: "Quantidade de OS-m mensal por fiscal",
          to: { name: "app.indicadores.osm.fiscaisByMonth" },
          acl: ["admin", "indicadores", "ordem_servicos", "fiscais_por_meses"],
        },
        {
          icon: "fa fa-user",
          title: "Por fiscal e dias",
          subtitle: "Quantidade de OS-m diário por fiscal",
          to: { name: "app.indicadores.osm.fiscaisPorDias" },
          acl: ["admin", "indicadores", "ordem_servicos", "fiscais_por_dias"],
        },
        {
          icon: "fa fa-users",
          title: "Por fiscais Andamento/Distribuição",
          subtitle: "Quantidade de OS-m diário por fiscal",
          to: { name: "app.indicadores.osm.fiscaisAndamentoDistribuicao" },
          acl: [
            "admin",
            "indicadores",
            "ordem_servicos",
            "fiscais_andamento_distribuicao",
          ],
        },
        {
          icon: "fa fa-globe",
          title: "Por zona",
          subtitle: "Quantidade de OS-m mensal por zona",
          to: { name: "app.indicadores.osm.porZona" },
          acl: ["admin", "indicadores", "ordem_servicos", "zonas"],
        },
        {
          icon: "fa fa-puzzle-piece",
          title: "Por assunto/fiscal",
          subtitle: "Quantidade de OS-m mensal por assunto/fiscal",
          to: { name: "app.indicadores.osm.porAssuntoFiscal" },
          acl: [
            "admin",
            "indicadores",
            "ordem_servicos",
            "fiscais_por_assuntos",
          ],
        },
        {
          icon: "fa fa-hourglass-start",
          title: "Tempo médio por assunto",
          subtitle: "Média de tempo para concluir a OS-m por assunto",
          to: { name: "app.indicadores.osm.tempoMedioPorAssuntos" },
          acl: [
            "admin",
            "indicadores",
            "ordem_servicos",
            "tempo_medio_por_assuntos",
          ],
        },
        {
          icon: "fa fa-hourglass-start",
          title: "Tempo médio por fiscal",
          subtitle: "Média de tempo para concluir a OS-m por fiscais",
          to: { name: "app.indicadores.osm.tempoMedioPorFiscais" },
          acl: [
            "admin",
            "indicadores",
            "ordem_servicos",
            "tempo_medio_por_fiscais",
          ],
        },
        {
          icon: "fa fa-map-marker",
          title: "Pontos no mapa",
          subtitle: "Pontos no mapa com os cadastros das OS-m",
          to: { name: "app.indicadores.osm.mapaPontos" },
          acl: ["admin", "indicadores", "ordem_servicos", "mapas", "pontos"],
        },
        {
          icon: "fa fa-map",
          title: "Densidade no mapa",
          subtitle: "Mapa com a demarcação de densidade por incidência de OS-m",
          to: { name: "app.indicadores.osm.mapaDensidade" },
          acl: ["admin", "indicadores", "ordem_servicos", "mapas", "densidade"],
        },
      ]
    },
  },
}
</script>
